import { utilsForUser } from '@tencent/wuji-utils';
import * as yaml from 'js-yaml';
import { marked } from 'marked';
import * as pako from 'pako';
export const platformBuiltinModules = {
    axios: () => utilsForUser.axios,
    lodash: () => utilsForUser.lodash,
    dayjs: () => utilsForUser.dayjs,
    ajv: () => utilsForUser.ajv,
    'crypto-js': () => utilsForUser.crypto,
    'js-yaml': () => yaml,
    marked: () => Object.assign({ __esModule: true, default: marked, marked }, marked),
    pako: () => pako,
    Buffer: () => utilsForUser.Buffer,
    qs: () => utilsForUser.qs,
};
